enum RoutesEnum {
  ROOT = '/',
  // E8 F8-1/F8-2/F8-6: explicit unauthenticated login landing, the MSAL redirect reply route, and the
  // post-logout landing.
  LOGIN = '/login',
  AUTH_CALLBACK = '/auth/callback',
  SIGNED_OUT = '/signed-out',
  // E10 F10-3: the public invitation acceptance landing (anonymous preview -> prompt=create sign-up ->
  // authed accept -> persona-splash). Handled by AppShell as a public route (pathname.startsWith).
  INVITATION = '/invitation/:token',
  // E20 F20-7 (WI 794): the Microsoft admin-consent return leg. Handled by AppShell as a public route
  // (pathname.startsWith) — the consenting admin may have no LogikSpark session.
  FEDERATION_CONSENT = '/federation-consent/:consentStateKey',
  // E8 F8-5 (story 8.5.2): the cross-subdomain persona-switch landing. PersonaGate resolves the persona
  // from ?personaId here, then this route redirects on into the app (so it never falls through to NoMatch).
  PERSONA_SPLASH = '/persona-splash',
  DASHBOARD = '/dashboard',
  SETTINGS = '/settings',
  SHIPMENTS = '/shipping/shipments',
  JOURNEY = '/shipping/journeys',
  JOURNEY_PLANNER = '/shipping/journeys/planner',
  VIEW_SHIPMENT = '/shipping/shipments/:id',
  EDIT_SHIPMENT = '/shipping/shipments/:id/edit',
  ASSET_HIRES = '/assetHire',
  VIEW_ASSET_HIRE = '/assetHire/:id',
  EDIT_ASSET_HIRE = '/assetHire/:id/edit',
  CREATE_ASSET_HIRE = '/assetHire/create',
  LOCATIONS = '/datasets/locations',
  LOCATIONS_FUEL_STATIONS = '/datasets/locations/fuelStations',
  LOCATIONS_TERMINALS = '/datasets/locations/terminals',
  LOCATIONS_AIRPORTS = '/datasets/locations/airports',
  LOCATIONS_RAILWAY_STATIONS = '/datasets/locations/railwayStations',
  VIEW_LOCATION = '/datasets/locations/:id',
  EDIT_LOCATION = '/datasets/locations/:id/edit',
  CREATE_LOCATION = '/datasets/locations/create',
  CREATE_ASSET = '/datasets/assets/create',
  UNASSIGNED_ROUTES = '/shipping/transport/routes/unassigned',
  ASSETS = '/datasets/assets',
  WORKFORCE = '/datasets/workforce',
  WORKFORCE_TYPE = '/datasets/workforceType',
  SHIPMENT_STEPPER = '/shipping/shipments/create',
  CUSTOMERS = '/datasets/customers',
  SERVICES = '/datasets/services',
  CREATE_TRANSPORT = '/shipping/journeys/:journeyId/route/:id/transport/create',
  COMING_SOON = '/comingSoon',
  NO_MATCH = '*',
  BRANDING = '/settings/branding',
  VERIFIED_DOMAINS = '/settings/verifiedDomains',
  FEDERATION = '/settings/federation',
  // E11 R1 (WI 611): the platform Global-Admin impersonation grants page (GA-only; guarded in-page via
  // useMe().isGlobalAdmin — a non-GA sees a Forbidden panel and no grants API call is made).
  IMPERSONATION = '/settings/admin/impersonation',
  ASSET_SETTINGS = '/settings/assetSettings',
  USER_MANAGEMENT = '/settings/userManagement',
  ASSET_MANAGEMENT = '/settings/assetManagement',
  INTEGRATIONS = '/settings/integrations',
  SHIPPING = '/settings/shipping',
  ROLES_PERMISSIONS = '/settings/rolesPermissions',
  CURRENCY_SETTINGS = '/settings/currencies',
  CONTACTS_SETTINGS = '/settings/contacts',
  PRODUCT_GROUPS = '/settings/productGroups',
  PRODUCTS = '/datasets/products',
  TRANSPORT_JOB_LISTS = '/shipping/transportJobs',
  CARRIERS = '/datasets/carriers',
  DOCUMENT_TYPE = '/datasets/documentType',
  REPORTS = '/reports',
  LOAD_TEMPLATES = '/datasets/loadTemplates',
  BRANDS = '/datasets/brands',
}

export default RoutesEnum
